import * as React from "react";
import { Button as AButton, Col, Row, Spin, Tooltip } from "antd";
import { ButtonProps } from "antd/es/button";
import { LoadingOutlined } from "@ant-design/icons";
import { BemHelper } from "@/utils/BemHelper";
import classNames from "classnames";

type type = "ai" | "ai-gradient-pink";

const bem = new BemHelper("button-protec-custom");

export type Props = Omit<ButtonProps, "type"> & {
  type: type;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  tooltip?: React.ReactNode;
};

export const ButtonProtecCustom = ({
  type,
  leftIcon,
  rightIcon,
  tooltip,
  children,
  loading,
  className,
  ...props
}: Props) => {
  const btnProps: ButtonProps = { ...props };

  switch (type) {
    case "ai":
      className = classNames(className, bem.modifier("ai"));
      break;

    case "ai-gradient-pink":
      className = classNames(className, bem.modifier("ai-gradient-pink"));
      break;
  }

  const mainBody = (
    <AButton className={classNames(bem.block(), className)} {...btnProps} style={btnProps.style}>
      <Row justify='center' align='middle' gutter={5} wrap={false}>
        {loading && (
          <Col style={{ display: "flex", alignItems: "center" }}>
            <Spin
              size={btnProps.size == "middle" ? "default" : btnProps.size}
              indicator={<LoadingOutlined spin />}
            />
          </Col>
        )}
        {!loading && (
          <>
            {leftIcon && <Col style={{ display: "flex", alignItems: "center" }}>{leftIcon}</Col>}
            {children && <Col>{children}</Col>}
            {rightIcon && <Col style={{ display: "flex", alignItems: "center" }}>{rightIcon}</Col>}
          </>
        )}
      </Row>
    </AButton>
  );

  const prepare = tooltip ? (
    <Tooltip
      color='white'
      title={<span style={{ color: "black", fontSize: "14px", fontWeight: 600 }}>{tooltip}</span>}
    >
      <span>{mainBody}</span>
    </Tooltip>
  ) : (
    mainBody
  );

  return prepare;
};
